export default __webpack_public_path__ + "static/media/hourglass-inside-circle.4f9b3a71.svg";